import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { searchAndHighlight } from '../../utils/searchUtils';
import styles from './searchResultsPage.module.scss';

const SearchResultsPage: React.FC = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search).get('q');

  console.log('Search Query:', query);

  useEffect(() => {
    if (query) {
      searchAndHighlight(query);
    }
  }, [query]);

  return (
    <div className={styles.searchContainer}>
      <h1 className={styles.searchHeading}>Search Results for: {query}</h1>
      {/* The matching components will be highlighted automatically */}
    </div>
  );
};

export default SearchResultsPage;
